import { ValidationCheck } from '../../../../../../consts/validationCheck';

const VALIDATION_ERRORS = {
  [ValidationCheck.EmptyFile]: {
    title: 'Corrupted or empty files detected',
    note: 'This is likely caused by powering down the drone too quickly after the mission ends. Please wait 5–10 seconds after mission completion before powering off, and ensure you are using a fast enough SD card (V30/U3 rated). We will be in touch if your imagery needs to be reflown.',
  },
  [ValidationCheck.DistanceToSiteMeters]: {
    title: 'Uploaded images are too far from the project location',
    note: 'Please double-check that you are uploading photos for the correct project',
  },
  [ValidationCheck.ScanToPanoMissupload]: {
    title: 'Possible Ortho / Mapping photo detected',
    note: "It looks like mapping (ortho) photos were uploaded instead of 360 panorama photos. Please double-check that you're uploading the correct dataset",
  },
  [ValidationCheck.PanoToScanMissupload]: {
    title: 'Possible 360 Panorama photos detected',
    note: "It looks like 360 panorama photos were uploaded instead of mapping photos. Please double-check that you're uploading the correct dataset",
  },
  [ValidationCheck.GimbalAngleDegrees]: {
    title: 'Non-nadir photos detected',
    note: 'Some photos were not taken directly overhead (nadir, or 90 degrees straight down). Please review your dataset and remove them if necessary before re-uploading',
  },
  [ValidationCheck.DroneModelOk]: {
    title: 'Unsupported camera detected',
    note: 'Some photos were taken with a DJI Mavic 2 drone camera, which is not supported. Please inform the Operations team and schedule a reflight with a supported drone',
  },
  [ValidationCheck.BlurScore]: {
    title: 'Possibly blurry images detected',
    note: 'Some photos may appear blurry. Our QC algorithm checks image sharpness by analyzing the clarity of edges between pixels, less clarity suggests blur. This check may include false positives, so please inspect the images. If needed contact the Operations team to schedule a reflight',
  },
  [ValidationCheck.PhotoAgeHours]: {
    title: 'Date mismatch detected',
    note: "Some photos are more than 5 days from this upload's date. Check you're uploading the right dataset, all from one flight",
  },
  [ValidationCheck.PhotoFromFuture]: {
    title: 'Photos dated in the future',
    note: "Some photos are dated in the future — the drone's clock is wrong (the photos are fine). Fix its date and time before your next flight",
  },
};

export const getValidationError = (check: ValidationCheck) => VALIDATION_ERRORS[check];
